import { companyInfo } from '../data/siteData';

export default function TermsPage() {
  return (
    <div data-testid="terms-page" className="pt-20">
      {/* Header */}
      <section className="py-16 md:py-24 bg-[#F8F9FA]">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-light tracking-tight text-slate-900 font-outfit">
            Terms & Conditions
          </h1>
          <p className="text-slate-600 font-manrope mt-4">
            Last updated: January 2026
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 md:py-24">
        <div className="max-w-3xl mx-auto px-6 md:px-12">
          <div className="prose prose-slate max-w-none font-manrope">
            <h2 className="text-2xl font-semibold text-slate-900 font-outfit mb-4">
              Acceptance of Terms
            </h2>
            <p className="text-slate-600 mb-8">
              By accessing and using this website, you accept and agree to be bound by these 
              Terms and Conditions. If you do not agree to these terms, please do not use 
              our website.
            </p>

            <h2 className="text-2xl font-semibold text-slate-900 font-outfit mb-4">
              Use of Website
            </h2>
            <p className="text-slate-600 mb-4">You agree to use this website only for lawful purposes and in a way that does not:</p>
            <ul className="list-disc pl-6 text-slate-600 mb-8 space-y-2">
              <li>Infringe the rights of others</li>
              <li>Restrict or inhibit anyone's use of the website</li>
              <li>Violate any applicable laws or regulations</li>
              <li>Transmit any harmful or malicious content</li>
            </ul>

            <h2 className="text-2xl font-semibold text-slate-900 font-outfit mb-4">
              Property Information
            </h2>
            <p className="text-slate-600 mb-8">
              All property information, including prices, specifications, and availability, 
              is subject to change without notice. The information provided is for general 
              guidance only and should not be relied upon as the sole basis for making 
              any decisions.
            </p>

            <h2 className="text-2xl font-semibold text-slate-900 font-outfit mb-4">
              Intellectual Property
            </h2>
            <p className="text-slate-600 mb-8">
              All content on this website, including text, graphics, logos, images, and 
              software, is the property of {companyInfo.fullName} and is protected by 
              copyright and other intellectual property laws.
            </p>

            <h2 className="text-2xl font-semibold text-slate-900 font-outfit mb-4">
              Disclaimer
            </h2>
            <p className="text-slate-600 mb-8">
              This website is provided "as is" without any warranties, express or implied. 
              We do not guarantee the accuracy, completeness, or reliability of any content 
              on this website.
            </p>

            <h2 className="text-2xl font-semibold text-slate-900 font-outfit mb-4">
              Limitation of Liability
            </h2>
            <p className="text-slate-600 mb-8">
              {companyInfo.fullName} shall not be liable for any direct, indirect, incidental, 
              or consequential damages arising from your use of this website or any linked sites.
            </p>

            <h2 className="text-2xl font-semibold text-slate-900 font-outfit mb-4">
              RERA Compliance
            </h2>
            <p className="text-slate-600 mb-8">
              All our projects are registered under the Real Estate (Regulation and Development) 
              Act, 2016 (RERA). Individual project RERA numbers are displayed on their 
              respective pages.
            </p>

            <h2 className="text-2xl font-semibold text-slate-900 font-outfit mb-4">
              Changes to Terms
            </h2>
            <p className="text-slate-600 mb-8">
              We reserve the right to modify these terms at any time. Changes will be 
              effective immediately upon posting on the website. Your continued use of 
              the website constitutes acceptance of the modified terms.
            </p>

            <h2 className="text-2xl font-semibold text-slate-900 font-outfit mb-4">
              Governing Law
            </h2>
            <p className="text-slate-600 mb-8">
              These terms shall be governed by and construed in accordance with the laws 
              of India. Any disputes shall be subject to the exclusive jurisdiction of 
              the courts in Nagpur, Maharashtra.
            </p>

            <h2 className="text-2xl font-semibold text-slate-900 font-outfit mb-4">
              Contact Information
            </h2>
            <p className="text-slate-600">
              For any questions regarding these terms, please contact us at:<br /><br />
              <strong>Email:</strong> {companyInfo.email}<br />
              <strong>Phone:</strong> {companyInfo.phone}<br />
              <strong>Address:</strong> {companyInfo.address}
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
